import { CartActionType, ICartAction, ICartProductStatus, ProductStatusType } from "../actions/action";

export interface ICartState {
  productStatus: ICartProductStatus
}

export const initialCartProductState: ICartState = {
  productStatus: {
    title: '',
    description: '',
    type: ProductStatusType.EMPTY,
    action: '' as CartActionType
  }
}

export const CartReducer = (state: ICartState, action: ICartAction): ICartState => {
  if (action.type === CartActionType.CLOSE_MODEL) {
    return initialCartProductState;
  }
  if (Object.keys(CartActionType).indexOf(action.type) > -1) {
    return {
      ...state,
      productStatus: action?.payload
    }
  }
  return state
}